import { BasePayment } from "./BasePayment";

export class PaymentUtils {
  static setIsSuccess = (payment: BasePayment) => {
    if (payment) {
      const responseCode: number = payment.responseCode || 0;
      payment.isSuccess = responseCode.toString() === "1";
    }
  }
}